exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circle-box {\r\n    background: no-repeat center center; \r\n    background-size: cover;\r\n    border-radius: 50%;\r\n    max-width: 240px;\r\n    background-image: url(/image/profile/070420172018350518438001499210315.jpeg);\r\n    max-height: 240px;\r\n    margin: 0 auto;\r\n    width: 70vw;\r\n    height: 70vw;\r\n    position: relative;\r\n    display: inline-block;\r\n    background-color: white;\r\n}", ""]);

// exports
